import styles from './style.module.css';
import {useAtomValue} from 'jotai';
import {classes} from '@/util';
import {userAtom} from '@/store/user';
import {logout} from '@/actions/auth';
import {ValueSkeleton} from '@/components/skeleton/value';
import {usePermissions} from '@/hooks/usePermissions';
import {formatNumber} from '@/util/date-format';

interface UserSectionProps {
    className?: string;
    variant?: 'default' | 'auth';
}

export function UserSection({
    className,
    variant = 'default',
}: UserSectionProps) {
    const user = useAtomValue(userAtom);
    const {hasAccess} = usePermissions();

    // For auth variant, only show when user exists
    // For default variant, show loading states when no user
    if (variant === 'auth' && !user) return null;

    return (
        <div
            className={classes(styles.userSection, className, styles[variant])}
        >
            {variant === 'default' && (
                <button className={styles.logoutButton} onClick={logout}>
                    log out
                </button>
            )}
            <div className={styles.separator}></div>
            <div className={styles.userInfo}>
                <span className={styles.username}>
                    <ValueSkeleton
                        value={user?.profile?.username ?? user?.email}
                        isLoading={!user}
                        width={90}
                        height={15}
                    />
                </span>
                <div className={styles.userDetails}>
                    <span className={styles.membershipInfo}>
                        <span>
                            <ValueSkeleton
                                value={user?.membership?.name.toLowerCase()}
                                isLoading={!user}
                                width={60}
                                height={14}
                            />
                        </span>
                        {hasAccess('view-credits') && (
                            <span>
                                <ValueSkeleton
                                    isLoading={!user}
                                    width={89}
                                    height={14}
                                    value={`${formatNumber(user?.credits)} credits`}
                                />
                            </span>
                        )}
                    </span>
                </div>
            </div>
            <div className={styles.avatar}>
                {user?.profile?.avatar?.url && (
                    <img
                        src={user.profile.avatar.url}
                        alt={user?.profile?.username || 'User Avatar'}
                    />
                )}
            </div>
        </div>
    );
}
